<template>
	<div class="slider">
		<header class="header">
			<div class="nickName-box">
				{{ loginMsg.nickName }}
			</div>
			<el-dropdown trigger="click" placement="top-start">
				<div class="avatar">
					<img v-if="avatar" :src="avatar" />
				</div>
				<el-dropdown-menu class="user-dropdown" slot="dropdown">
					<el-dropdown-item>
						<span @click="logout" style="display: block">退出</span>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</header>
		<ul class="slider-nav">
			<li v-for="(item, index) in navSrc" :key="index" @click="goMenu(index, item.path)">
				<img :src="current == index ? item.img : noActivePic[index].img" alt="" :title="item.name" />
				<span>{{ item.name }}</span>
				<span :class="uploadMemeNum < 10 ? 'badge' : 'badge2'"
					v-if="item.name == '私信' && upDateMessageNum > 0">{{ upDateMessageNum }}</span>
				<span :class="upDateEmailNum < 10 ? 'badge' : 'badge2'"
					v-if="item.name == '邮箱' && upDateEmailNum > 0">{{ upDateEmailNum }}</span>
				<span :class="uploadMemeNum < 10 ? 'badge' : 'badge2'"
					v-if="item.name == '上传表情' && uploadMemeNum > 0">{{ uploadMemeNum }}</span>
				<span :class="uploadMusicNum < 10 ? 'badge' : 'badge2'"
					v-if="item.name == '上传音乐' && uploadMusicNum > 0">{{ uploadMusicNum }}</span>
				<span :class="uploadZhiKNum < 10 ? 'badge' : 'badge2'" v-if="item.name == '发蜘客' && uploadZhiKNum > 0">{{
					uploadZhiKNum }}</span>
				<span :class="upDateGroupNum < 10 ? 'badge' : 'badge2'"
					v-if="item.name == '秘书台' && upDateGroupNum > 0">{{ upDateGroupNum }}</span>
			</li>
		</ul>

		<!-- 年费付款弹窗 -->
		<el-dialog
			
			:visible.sync="feeDialogVisible"
			width="370px"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			custom-class="fee-dialog"
			@opened="onFeeDialogOpened"
			@closed="handleFeeDialogClosed"
		>
			<div class="fee-dialog-body">
				<div v-show="paymentSuccess" class="payment-success-area">
					<div class="success-icon">✓</div>
					<p class="success-text">支付成功</p>
				</div>
				<div v-show="!paymentSuccess">
					<p class="fee-status-text" v-if="feeDialogStatusText">{{ feeDialogStatusText }}</p>
					<p class="fee-price">蜘币：{{ feeDialogPrice }}元</p>
					<div class="fee-qrcode-area">
						<div id="feeQrCodeUrl" ref="feeQrCodeUrl"></div>
					</div>
					<p class="fee-tip">请使用蜘信扫一扫完成支付</p>
					<el-button type="primary" size="small" @click="confirmPaymentManually" style="margin-top: 10px;">
						已支付，刷新状态
					</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import api from "@/api/api";
import {
	mapState
} from "vuex";
import init from "@/assets/js/rongyun.js";
import QRCode from "qrcodejs2";

export default {
	data() {
		return {
			RongIMClient: null, //融云实例
			userInfo: {}, //用户信息
			loginMsg: {}, //登录信息
			current: 0,
			badge: 0, // 标记
			artistStatus: 0, //艺术家状态
			musicStatus: 0, //音乐家状态
			avatar: null, // 头像
			noActivePic: [{
				img: require("@/assets/images/ic_sixin1@3x.png"),
				name: "私信",
			},
			{
				img: require("@/assets/images/ic_ic_tongxunlu1@3x.png"),
				name: "通讯录",
			},
			{
				img: require("@/assets/images/ic_mishutai1@3x.png"),
				name: "秘书台",
			},
			{
				img: require("@/assets/images/ic_youjian1@3x.png"),
				name: "邮箱",
			},
			{
				img: require("@/assets/images/ic_xiezhike1@3x.png"),
				name: "发蜘客",
			},
			// {
			//   img: require("@/assets/images/ic_wenjian1@3x.png"),
			//   name: "文件",
			// },
			{
				img: require("@/assets/images/ic_yinyue1@3x.png"),
				name: "上传音乐",
			},
			{
				img: require("@/assets/images/ic_biaoqing1@3x.png"),
				name: "上传表情",
				num: "",
			},
			{
				img: require("@/assets/images/ic_biaoqing1@3x.png"),
				name: "上传视频",
				num: "",
			},
			],
			navSrc: [{
				img: require("@/assets/images/ic_sixin2@2x.png"),
				name: "私信",
				path: "/index/privateLetter",
			},
			{
				img: require("@/assets/images/ic_ic_tongxunlu2@3x.png"),
				name: "通讯录",
				path: "/index/addressbook",
			},
			{
				img: require("@/assets/images/ic_mishutai2@3x.png"),
				name: "秘书台",
				path: "/index/secretaryStation",
			},
			{
				img: require("@/assets/images/ic_youjian2@3x.png"),
				name: "邮箱",
				path: "/index/mailbox",
			},
			{
				img: require("@/assets/images/ic_xiezhike2@3x.png"),
				name: "发蜘客",
				path: "/index/sendSpider",
			},
			// {
			//   img: require("@/assets/images/ic_wenjian2@3x.png"),
			//   name: "文件",
			//   path: "/index/file",
			// },
			{
				img: require("@/assets/images/ic_yinyue2@3x.png"),
				name: "上传音乐",
				path: "/index/uploadMusic",
			},
			{
				img: require("@/assets/images/ic_biaoqing2@3x.png"),
				name: "上传表情",
				path: "/index/uploadExpression",
			},
			{
				img: require("@/assets/images/ic_shipin1@2x.png"),
				name: "上传视频",
				path: "/index/uploadVideo",
			},
			],

			statusCheckTimer: null,
			lastKnownArtistStatus: null,
			lastKnownMusicStatus: null,
			isCheckingStatus: false, // 是否正在检查状态
			messageListener: null, // 消息监听器实例
			isSettingListener: false, // 是否正在设置监听器，避免递归调用
			rongyunStatusTimer: null, // 融云连接状态轮询定时器
			// 年费付款弹窗相关
			feeDialogVisible: false, // 付款弹窗是否显示
			feeDialogTitle: '', // 弹窗标题（企业蜘客/媒体蜘客）
			feeDialogStatusText: '', // 弹窗状态提示文案（体验期满/已逾期...）
			feeDialogPrice: 0, // 年费价格
			feeQrcode: null, // 二维码实例
			feeCheckingLoading: false, // 正在检查年费状态
			feePollingTimer: null, // 付款状态轮询定时器
			feePollingCount: 0, // 轮询次数（超时保护）
			pendingNavigatePath: '', // 付款成功后待跳转的路径
			paymentSuccess: false, // 支付成功状态（用于收起二维码并显示提示）
			feeScene: 'zhike', // 当前年费场景：'zhike'=蜘客(55/56) 'zhiying'=蜘影(57/58)
			currentFeeInfo: null, // 当前弹窗使用的空间年费信息
			feeSuccessHandled: false,
		}
	},
	created() {
		console.log('slider-bar组件开始初始化');
		this.initRongyun(); //初始化融云实例
		this.getArtistStatus(); //获取艺术家空间开通状态 0未开通  1开通
		if (window.localStorage.getItem("index")) {
			let indexs = window.localStorage.getItem("index");
			this.current = indexs;
			this.goMenu(this.current, this.navSrc[this.current].path)
		}
		this.getNum();
		this.isOpenZone() //获取是否开通蜘信空间

		// 监听秘书台未读更新事件
		this.$root.$on('secretary-unread-updated', this.handleSecretaryUnreadUpdated);
		console.log('slider-bar: 已添加secretary-unread-updated事件监听器');

		this.startStatusPolling();
		console.log('slider-bar组件初始化完成');
	},
	// created() {
	// 	console.log('slider-bar组件开始初始化');
	// 	this.initRongyun(); //初始化融云实例
	// 	this.getArtistStatus(); //获取艺术家空间开通状态 0未开通  1开通
	// 	if (window.localStorage.getItem("index")) {
	// 		let indexs = window.localStorage.getItem("index");
	// 		this.current = indexs;
	// 		this.goMenu(this.current, this.navSrc[this.current].path)
	// 	}
	// 	this.getNum();
	// 	this.isOpenZone() //获取是否开通蜘信空间

	// 	this.startStatusPolling();
	// 	console.log('slider-bar组件初始化完成');
	// },
	// 添加activated生命周期钩子
	activated() {
		console.log('slider-bar组件被激活');
		// 不再自动重新计算秘书台未读数，避免点击秘书台时红点消失
		// 只有当通道红点消除后，秘书台的红点数量才会相应减少
		console.log('跳过自动重新计算秘书台未读数，避免点击秘书台时红点消失');
	},
	beforeDestroy() {
		this.stopStatusPolling();
		this.stopFeePolling();
		// 移除事件监听器
		this.$root.$off('secretary-unread-updated', this.handleSecretaryUnreadUpdated);
		console.log('slider-bar: 已移除secretary-unread-updated事件监听器');
	},
	computed: {
		...mapState({
			uploadMemeNum: (state) => state.updateNum.uploadMemeNum, //上传表情包数量
			uploadMusicNum: (state) => state.updateNum.uploadMusicNum, //上传音乐数量
			uploadZhiKNum: (state) => state.updateNum.uploadZhiKNum, //发蜘客的数量
			upDateMessageNum: (state) => state.updateNum.upDateMessageNum, //私信的数量
			upDateGroupNum: (state) => state.updateNum.upDateGroupNum, //秘书台的数量
			upDateEmailNum: (state) => state.updateNum.upDateEmailNum, //邮箱的数量
			targetId: (state) => state.rongyun.targetId, //当前聊天的目标id
		}),
	},
	watch: {
		//监听表情包的数量变化
		uploadMemeNum(newVal, oldVal) {
			oldVal = newVal;
		},
		//监听上传音乐的数量变化
		uploadMusicNum(newVal, oldVal) {
			oldVal = newVal;
		},
		//监听发蜘客的数量变化
		uploadZhiKNum(newVal, oldVal) {
			oldVal = newVal;
		},
		//监听私信的数量变化
		upDateMessageNum(newVal, oldVal) {
			console.log('私信未读数变化', oldVal, '->', newVal);
			oldVal = newVal;
		},
		//监听秘书台数量变化
		upDateGroupNum(newVal, oldVal) {
			console.log('秘书台未读数变化', oldVal, '->', newVal);
			oldVal = newVal;
			// 强制组件更新，确保界面能实时显示最新的未读数量
			this.$forceUpdate();
		},
		//监听邮箱数量变化
		upDateEmailNum(newVal, oldVal) {
			oldVal = newVal;
		},
		//融云
		RongIMClient(newVal, oldVal) {
			oldVal = newVal;
			// 当融云实例变化时，重新设置消息监听
			if (newVal) {
				console.log('融云实例变化，重新设置消息监听');
				this.watchM();
			}
		},
		//监听targetId 正在聊天的目标id
		targetId(newVal, oldVal) {
			oldVal = newVal;
		}
	},
	methods: {
		//获取是否开通蜘客空间
		isOpenZone() {
			this.$api.userMsg.isOpenBlog().then(res => {
				// console.log("成功========",res.result.spiderBlogFlag)
				let userInfo = JSON.parse(localStorage.getItem("loginMsg")); //存在缓存的用户信息
				// console.log("信息========",userInfo)
				userInfo.spiderBlogFlag = res.result.spiderBlogFlag;
				localStorage.setItem("loginMsg", JSON.stringify(userInfo));
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 初始化融云实例
		// 修改 slider-bar.vue 中的 initRongyun 方法
		initRongyun() {
			console.log('=== slider-bar: 开始初始化融云实例 ===');
			let userInfo = JSON.parse(localStorage.getItem("loginMsg")); //存在缓存的用户信息
			console.log('=== slider-bar: 用户信息:', userInfo);
			this.loginMsg = userInfo; //用户信息
			this.userInfo.appKey = "tdrvipkst29q5"; //appkey
			this.userInfo.token = userInfo.tripartiteToken;
			console.log('=== slider-bar: 融云初始化参数:', this.userInfo);
			this.RongIMClient = init(this.userInfo);
			console.log('=== slider-bar: 融云实例初始化结果:', this.RongIMClient);
			this.$store.commit("setRongIMClient", this.RongIMClient);
			console.log('=== slider-bar: 融云实例已保存到Vuex ===');
			// 立即设置消息监听
			this.watchM();
			console.log('=== slider-bar: 融云初始化完成 ===');
		},
		//slider-bar 是主要链接融云的地方 但是会在spider-window-messagebox文件从新再连接 就是点击了某个人或者群组聊天的时候 有些值会修改的方便些
		//监听
		// 修改 slider-bar.vue 中的 watchM 方法
		watchM() {
			console.log('=== slider-bar: 开始设置融云消息监听 ===');
			console.log('=== slider-bar: RongIMClient:', this.RongIMClient);
			console.log('=== slider-bar: window.RongIMLib:', window.RongIMLib);
			if (!this.RongIMClient) {
				console.error('=== slider-bar: RongIMClient 不存在，无法设置消息监听 ===');
				return;
			}
			
			// 保存消息监听实例，以便后续可以清除
			if (this.messageListener) {
				console.log('=== slider-bar: 清除之前的消息监听 ===');
				// 清除之前的监听器（如果存在）
				try {
					this.RongIMClient.removeListener(this.messageListener);
				} catch (error) {
					console.error('=== slider-bar: 清除监听器失败:', error);
				}
			}
			
			// 重新设置监听
			this.messageListener = this.RongIMClient.watch({
				// 监听消息通知
				message: (event) => {
					// 新接收到的消息内容
					const timestamp = new Date().toLocaleTimeString();
					console.log(`[${timestamp}] === slider-bar: 收到融云消息事件 ===`);
					const message = event.message;
					console.log(`[${timestamp}] === slider-bar: 消息内容:`, message);
					
					// 生成消息唯一标识，避免重复处理
					const msgKey = `${message.messageId || message.sentTime}_${message.senderUserId}_${message.targetId}`;
					if (this.processedMessages && this.processedMessages.has(msgKey)) {
						console.log(`[${timestamp}] === slider-bar: 消息已处理过，跳过 ===`);
						return;
					}
					if (!this.processedMessages) {
						this.processedMessages = new Set();
					}
					this.processedMessages.add(msgKey);
					// 5 秒后从集合中移除，避免内存泄漏
					setTimeout(() => {
						this.processedMessages.delete(msgKey);
					}, 5000);
					
					// 处理私信消息
					if (message.type === 1) { // 1 表示私信
						// 过滤融云"正在输入"(typing indicator) 状态消息
						// 这类消息 messageType 是 RC:TxtMsg 但 content.content 为空，不是真实消息
						if (this.isTypingIndicator(message)) {
							console.log(`[${timestamp}] === slider-bar: 跳过 typing indicator 状态消息 ===`);
							return;
						}
						console.log(`[${timestamp}] === slider-bar: 处理私信消息 ===`);
						const currentUserId = this.loginMsg.memberId;
						const senderUserId = message.senderUserId;
						console.log(`[${timestamp}] === slider-bar: 当前用户 ID: ${currentUserId}, 消息发送者 ID: ${senderUserId}`);
						
						// 注意：即使是自己发送的消息，也需要处理
						// 因为用户可能在其他设备（如手机）发送消息，当前页面需要显示
						
						// 触发私信消息事件，通知私信页面
						console.log(`[${timestamp}] === slider-bar: 触发 new-private-message 事件 ===`);
						this.$root.$emit('new-private-message', message);
					}
					// 处理群组消息
					else if (message.type === 3) { // 3 表示群组消息
						console.log(`[${timestamp}] === slider-bar: 处理群组消息 ===`);
						const groupId = message.targetId;
						const currentTargetId = this.$store.state.rongyun.targetId;
						const currentUserId = this.loginMsg.memberId;
						const senderUserId = message.senderUserId;
						console.log(`[${timestamp}] === slider-bar: 群组 ID: ${groupId}, 当前聊天 ID: ${currentTargetId}`);
						console.log(`[${timestamp}] === slider-bar: 当前用户 ID: ${currentUserId}, 消息发送者 ID: ${senderUserId}`);
						
						// 确保消息有必要的字段
						if (!groupId || !senderUserId) {
							console.error(`[${timestamp}] === slider-bar: 消息缺少必要字段，跳过处理 ===`);
							return;
						}
						
						// 注意：即使是自己发送的消息，也需要处理
						// 因为用户可能在其他设备（如手机）发送消息，当前页面需要显示
						console.log(`[${timestamp}] === slider-bar: 当前用户 ID: ${currentUserId}, 消息发送者 ID: ${senderUserId}`);
						
						try {
							// 处理群通知消息
							if (message.messageType === 'ST:GrpNtf' && message.content && message.content.operation) {
								console.log(`[${timestamp}] === slider-bar: 处理群通知消息: ${message.content.operation} ===`);
								// 处理用户被移出群聊的消息
								if (message.content.operation === 'Kicked') {
									console.log(`[${timestamp}] === slider-bar: 用户被移出群聊 ===`);
									// 触发群踢人消息事件
									this.$root.$emit('group-kickout-message', message);
									
									// 将被移出的群组添加到本地存储，用于计算未读数
									const kickedGroups = JSON.parse(localStorage.getItem('kickedGroups') || '[]');
									if (!kickedGroups.includes(groupId)) {
										kickedGroups.push(groupId);
										localStorage.setItem('kickedGroups', JSON.stringify(kickedGroups));
										console.log(`[${timestamp}] === slider-bar: 将群组 ${groupId} 添加到被移出列表 ===`);
									}
									
									// 立即更新秘书台未读数，确保红点显示
									console.log(`[${timestamp}] === slider-bar: 立即更新秘书台未读数 ===`);
									this.recalculateSecretaryUnread().then(count => {
										console.log(`[${timestamp}] === slider-bar: 秘书台未读数计算结果: ${count} ===`);
										// 强制更新DOM，确保即使在私信视图也能看到未读数量更新
										this.updateSecretaryBadgeDirectly();
										// 强制组件更新，确保界面能实时显示最新的未读数量
										this.$forceUpdate();
										
										// 再次更新DOM，确保更新生效
										setTimeout(() => {
											this.updateSecretaryBadgeDirectly();
											this.$forceUpdate();
											console.log(`[${timestamp}] === slider-bar: 再次更新秘书台未读数量 ===`);
										}, 100);
									}).catch(error => {
										console.error(`[${timestamp}] === slider-bar: 计算未读数失败:`, error);
									});
									
									// 触发秘书台未读更新事件
									console.log(`[${timestamp}] === slider-bar: 触发secretary-unread-updated事件 ===`);
									this.$root.$emit('secretary-unread-updated', {
										groupId: groupId,
										timestamp: Date.now()
									});
								}
								// 处理群解散消息
								else if (message.content.operation === 'Dismissed') {
									console.log(`[${timestamp}] === slider-bar: 群聊被解散 ===`);
									// 触发群解散消息事件
									this.$root.$emit('group-dissolve-message', message);
									
									// 立即更新秘书台未读数，确保红点显示
									console.log(`[${timestamp}] === slider-bar: 立即更新秘书台未读数 ===`);
									this.recalculateSecretaryUnread().then(count => {
										console.log(`[${timestamp}] === slider-bar: 秘书台未读数计算结果: ${count} ===`);
										// 强制更新DOM，确保即使在私信视图也能看到未读数量更新
										this.updateSecretaryBadgeDirectly();
										// 强制组件更新，确保界面能实时显示最新的未读数量
										this.$forceUpdate();
										
										// 再次更新DOM，确保更新生效
										setTimeout(() => {
											this.updateSecretaryBadgeDirectly();
											this.$forceUpdate();
											console.log(`[${timestamp}] === slider-bar: 再次更新秘书台未读数量 ===`);
										}, 100);
									}).catch(error => {
										console.error(`[${timestamp}] === slider-bar: 计算未读数失败:`, error);
									});
									
									// 触发秘书台未读更新事件
									console.log(`[${timestamp}] === slider-bar: 触发secretary-unread-updated事件 ===`);
									this.$root.$emit('secretary-unread-updated', {
										groupId: groupId,
										timestamp: Date.now()
									});
								}
							}
							else {
								// 处理普通群组消息
							// 1. 通知所有组件（包括秘书台）有新消息
							console.log(`[${timestamp}] === slider-bar: 触发new-group-message事件 ===`);
							this.$root.$emit('new-group-message', message);
							
							// 2. 延迟更新秘书台未读数，避免与秘书台组件的更新冲突
							setTimeout(() => {
								console.log(`[${timestamp}] === slider-bar: 延迟更新秘书台未读数 ===`);
								this.recalculateSecretaryUnread().then(count => {
									console.log(`[${timestamp}] === slider-bar: 秘书台未读数计算结果: ${count} ===`);
									// 强制更新DOM，确保即使在私信视图也能看到未读数量更新
									this.updateSecretaryBadgeDirectly();
									// 强制组件更新，确保界面能实时显示最新的未读数量
									this.$forceUpdate();
								}).catch(error => {
									console.error(`[${timestamp}] === slider-bar: 计算未读数失败:`, error);
								});
							}, 200);
							}
							
							// 4. 如果用户正在该群聊天，直接通知聊天窗口
							if (currentTargetId && currentTargetId.toString() === groupId.toString()) {
								console.log(`[${timestamp}] === slider-bar: 用户正在该群聊天，通知聊天窗口 ===`);
								this.$root.$emit('group-message-in-chat', message);
							}
						} catch (error) {
							console.error(`[${timestamp}] === slider-bar: 处理群组消息失败:`, error);
							// 即使出错，也要继续处理其他消息
						}
					}
				},
				// 监听 IM 连接状态变化
				status: (event) => {
					console.log("融云连接状态:", event.status);
					if (event.status == 1) {
						console.log("链接中");
					}
					if (event.status == 0) {
						console.log("链接成功");
						// 连接成功后，重新设置消息监听
						console.log('连接成功，重新设置消息监听');
						// 避免递归调用，只设置一次监听
						if (!this.isSettingListener) {
							this.isSettingListener = true;
							this.watchM();
							this.isSettingListener = false;
						}
						// 更新消息数
						this.$store.dispatch('changeMsgNum', this)
						// 更新群组状态
						this.$store.commit('changeGroupList')
						// 获取未读消息数
						setTimeout(() => {
							this.getNoReadNum();
							// 重新计算秘书台未读数
							this.recalculateSecretaryUnread();

							// 立即更新秘书台未读数量 - 确保红点显示
							console.log('连接成功 - 立即更新秘书台未读数量');
							this.immediateUpdateSecretaryUnread();
						}, 1000);
					} else if (event.status == 6) {
						// 连接断开，尝试重连
						console.log("连接断开，尝试重连...");
						setTimeout(() => {
							this.RongIMClient.reconnect();
						}, 1000);
					} else if (event.status == 2) {
						console.log("连接断开");
					} else if (event.status == 3) {
						console.log("重连中");
					} else if (event.status == 4) {
						console.log("重连失败");
					} else if (event.status == 5) {
						console.log("被踢下线");
					}
				}
			});
			console.log('=== slider-bar: 消息监听设置完成 ===');
		},
		//获取会话未读数 全部的会话未读
		getNoReadNum() {
			let conversationTypes = [window.RongIMLib.CONVERSATION_TYPE.SYSTEM];
			this.RongIMClient.Conversation.getTotalUnreadCount(
				false,
				conversationTypes
			).then((totalUnreadCount) => {
				// console.log("获取未读总数成功", totalUnreadCount);
				this.$store.dispatch("changeMsgNum", this);
			});
		},
		//获取每个模块的数值
		getNum() {
			this.$store.dispatch("changeNum", "上传表情").then((res) => {
				//  console.log("上传表情",res,this.uploadMemeNum)
			});
			// this.$store.dispatch("changeNum", "上传音乐").then((res) => {
			// 	//  console.log("上传音乐",res,this.uploadMusicNum)
			// });
			// this.$store.dispatch("changeNum", "发蜘客").then((res) => {
			// 	//  console.log("发蜘客",res)
			// });
			//邮箱
			this.$store.dispatch("changeNum", "邮箱").then((res) => {
				//  console.log("邮箱",res)
			});
			//vuex更新数量 传名称
		},
		// 跳转对应菜单界面
		async goMenu(index, path) {
			// if (path == "/index/uploadMusic" && this.musicStatus != 1) {
			// 	this.$message({
			// 		message: "您还没有开通音乐家空间",
			// 		type: "warning",
			// 	});
			// 	return;
			// }
			if (path === '/index/uploadMusic') {
				// 防止重复点击
				if (this.isCheckingStatus) return;
			
				try {
					this.isCheckingStatus = true; // 开始加载
					// 关键：主动请求最新状态（忽略本地缓存，强制拉取服务器数据）
					await this.getArtistStatus(); 

					// 使用最新状态判断（确保是接口返回的实时数据）
					if (this.musicStatus === 1) { // 根据实际状态值调整
						this.$router.push(path); // 状态通过，跳转
					} else {
						this.$message({
							message: "您还没有开通音乐家空间",
							type: "warning",
						});
					}
				} catch (err) {
					Message.error('状态获取失败，请重试');
					console.error('状态请求异常:', err);
				} finally {
					this.isCheckingStatus = false; // 结束加载
				}
			} 
			//判断是否开启艺术家空间 阻止跳转
			if (path == "/index/uploadExpression" && this.artistStatus == 0) {
				this.$message({
					message: "您还没有开通艺术家空间",
					type: "warning",
				});
				return;
			}
			if (
				path == "/index/sendSpider" &&
				JSON.parse(localStorage.getItem("loginMsg")).spiderBlogFlag == 0
			) {
				// console.log("===", JSON.parse(localStorage.getItem("loginMsg")));
				this.$message({
					message: "您还没有开通蜘客空间",
					type: "warning",
				});
				return;
			}
			// 发蜘客：检查年费状态
			if (path == "/index/sendSpider" && !this.feeCheckingLoading) {
				const loginMsg = JSON.parse(localStorage.getItem("loginMsg"));
				if (loginMsg && loginMsg.spiderBlogFlag == 1) {
					this.feeCheckingLoading = true;
					try {
						const feeOk = await this.checkFeeStatus('zhike');
						if (!feeOk) {
							this.pendingNavigatePath = path; // 记住付款成功后要跳转的路径
							return; // 弹窗已显示，不跳转
						}
					} catch (err) {
						console.error('年费状态检查失败:', err);
					} finally {
						this.feeCheckingLoading = false;
					}
				}
			}
			// 上传视频(企业蜘影/影视蜘影)：检查年费状态
			if (path == "/index/uploadVideo" && !this.feeCheckingLoading) {
				this.feeCheckingLoading = true;
				try {
					const feeOk = await this.checkFeeStatus('zhiying');
					if (!feeOk) {
						this.pendingNavigatePath = path; // 记住付款成功后要跳转的路径
						return; // 弹窗已显示，不跳转
					}
				} catch (err) {
					console.error('蜘影年费状态检查失败:', err);
				} finally {
					this.feeCheckingLoading = false;
				}
			}
			if (path != "/index/privateLetter" && path != "/index/secretaryStation" && path != "/index/addressbook") {
				localStorage.removeItem('chatRecords')
				this.$store.commit('setTargetId', '')
			}
			window.localStorage.setItem("index", index);
			this.current = index;
			this.$router.push({
				path: path
			});
		},
		// 检查年费状态，返回 true 表示可以正常进入，false 表示被拦截（弹窗显示）
		// scene: 'zhike'=蜘客(企业蜘客/媒体蜘客) 'zhiying'=蜘影(企业蜘影/影视蜘影)
		async checkFeeStatus(scene = 'zhike') {
			try {
				const spaceInfo = await this.fetchFeeSpaceInfo(scene);
				if (!spaceInfo) return true;

				const feeStatus = this.normalizeFeeStatus(spaceInfo.feeStatus);

				// feeStatus: 0=体验期内, 1=体验期满未付费, 2=已付费有效, 3=已逾期
				// PERSONAL 类型 feeStatus 为 null，直接放行
				if (feeStatus === null) return true;
				if (feeStatus === 0 || feeStatus === 2) return true;

				// feeStatus === 1 或 3 时，弹出付款二维码
				const title = this.getFeeDialogTitle(spaceInfo, scene);
				let statusText = '';
				if (feeStatus === 1) {
					statusText = `您的${title}半年体验期已满，缴付年费后才可发布`;
				} else if (feeStatus === 3) {
					statusText = `您的${title}已逾期，年费续付后才可发布`;
				}

				this.showFeeDialog(title, statusText, spaceInfo, scene);
				return false;
			} catch (err) {
				console.error(scene === 'zhiying' ? '获取蜘影信息失败:' : '获取蜘客信息失败:', err);
				return true;
			}
		},
		async fetchFeeSpaceInfo(scene = 'zhike') {
			const loginMsg = JSON.parse(localStorage.getItem("loginMsg"));
			if (!loginMsg || !loginMsg.memberId) return null;
			const res = scene === 'zhiying'
				? await this.$api.filmsFilmsInfo.spaceMemberInfo(loginMsg.memberId)
				: await this.$api.userMsg.getSpderBlogInfo(loginMsg.memberId);
			if (!res || !res.result) return null;
			return res.result;
		},
		// 判断是否是融云"正在输入"(typing indicator) 状态消息
		// typing 消息特征：messageType 通常是未知类型(如 RC:TypingStatus)，
		// content 含 typing 标识字段(如 typingContentType="RC:TxtMsg" 表示正在输入文本)
		// 这不是真实消息，只是对方正在输入的状态提示，不应显示或计数
		isTypingIndicator(message) {
			if (!message) return false;
			let content = message.content;
			if (typeof content === 'string') {
				try { content = JSON.parse(content); } catch(e) { content = {}; }
			}
			// 检查 content 是否含 typing 标识字段
			const typingKeys = ['typingContentType', 'isTyping', 'typing', 'typingStatus', 'typingMessageType'];
			if (content && typeof content === 'object') {
				for (const key of typingKeys) {
					if (key in content) {
						console.log('=== slider-bar: 检测到 typing indicator 消息，messageType:', message.messageType, 'content:', JSON.stringify(content));
						return true;
					}
				}
			}
			// 兜底：RC:TxtMsg 类型但 content.content 为空
			const msgType = message.messageType;
			const typeMap = { 1: 'RC:TxtMsg' };
			const strType = typeMap[msgType] || msgType;
			if (strType === 'RC:TxtMsg' && (!content || !content.content || String(content.content).trim() === '')) {
				console.log('=== slider-bar: 检测到空 content 的 RC:TxtMsg（typing indicator）');
				return true;
			}
			return false;
		},
		normalizeFeeStatus(val) {
			if (val === null || val === undefined || val === '') return null;
			const n = Number(val);
			return Number.isNaN(n) ? null : n;
		},
		isFeePaidStatus(feeStatus, info, allowExpireFallback) {
			if (feeStatus === 0 || feeStatus === 2) return true;
			if (!allowExpireFallback || !info) return false;
			const days = Number(info.remainingDays);
			if (!Number.isNaN(days) && days > 0) return true;
			if (info.feeExpireTime) {
				const expire = new Date(String(info.feeExpireTime).replace(/-/g, '/')).getTime();
				if (!Number.isNaN(expire) && expire > Date.now()) return true;
			}
			return false;
		},
		getFeeDialogTitle(info, scene = 'zhike') {
			if (scene === 'zhiying') {
				return this.isZhiyingEnterprise(info) ? '企业蜘影' : '影视蜘影';
			}
			return this.isZhikeEnterprise(info) ? '企业蜘客' : '媒体蜘客';
		},
		// 账号类型：PERSONAL / COMPANY / OFFICIAL
		getAccountKind(info) {
			if (!info) return '';
			let loginExtra = {};
			try {
				loginExtra = JSON.parse(localStorage.getItem('loginMsg') || '{}') || {};
			} catch (e) {
				loginExtra = {};
			}
			const merged = Object.assign({}, loginExtra, info);
			const matchKind = (raw, allowNumeric) => {
				if (raw === null || raw === undefined || raw === '') return '';
				const type = String(raw).toUpperCase();
				if (['PERSONAL', '个人'].includes(type) || (allowNumeric && type === '0')) return 'personal';
				if (['COMPANY', '企业', 'ENTERPRISE'].includes(type) || (allowNumeric && type === '1')) return 'company';
				if (['OFFICIAL', '官方', '媒体', '影视', 'MEDIA'].includes(type) || (allowNumeric && type === '2')) return 'official';
				return '';
			};
			const namedFields = [
				merged.spaceType, merged.accountType, merged.memberType, merged.identityType,
				merged.authType, merged.blogType, merged.companyType, merged.filmsType,
				merged.officialType, merged.spiderBlogType, merged.spaceMemberType,
			];
			for (let i = 0; i < namedFields.length; i++) {
				const kind = matchKind(namedFields[i], true);
				if (kind) return kind;
			}
			const nature = String(
				merged.companyNature || merged.nature || merged.industry || merged.category || merged.companyName || ''
			);
			if (nature.includes('媒体') || nature.includes('影视')) return 'official';
			if (nature.includes('企业')) return 'company';
			// 通用 type 只认明确的字符串，避免把业务数字 type 误当成身份
			const typeKind = matchKind(merged.type, false);
			if (typeKind) return typeKind;
			return '';
		},
		isZhikeEnterprise(info) {
			const kind = this.getAccountKind(info);
			if (kind === 'official') return false;
			if (kind === 'company') return true;
			const nature = String((info && (info.companyNature || info.nature)) || '');
			if (nature.includes('媒体')) return false;
			return true;
		},
		isZhiyingEnterprise(info) {
			const kind = this.getAccountKind(info);
			if (kind === 'official') return false;
			if (kind === 'company') return true;
			const nature = String((info && (info.companyNature || info.nature)) || '');
			if (nature.includes('影视')) return false;
			return true;
		},
		// 根据空间信息和场景获取 subtype
		// scene: 'zhike'=蜘客(55企业/56媒体) 'zhiying'=蜘影(57企业/58影视)
		getFeeSubtype(info, scene = 'zhike') {
			if (scene === 'zhiying') {
				return this.isZhiyingEnterprise(info) ? 57 : 58;
			}
			return this.isZhikeEnterprise(info) ? 55 : 56;
		},
		// 显示年费付款弹窗
		showFeeDialog(title, statusText, blogInfo, scene = 'zhike') {
			this.feeDialogTitle = title;
			this.feeDialogStatusText = statusText;
			this.feeDialogPrice = blogInfo.annualFeePrice || 0;
			this.paymentSuccess = false;
			this.feeScene = scene;
			this.feePollingCount = 0;
			this.currentFeeInfo = blogInfo;
			this.feeSuccessHandled = false;
			this.feeDialogVisible = true;
		},
		onFeeDialogOpened() {
			if (this.currentFeeInfo) {
				this.generateFeeQrcode(this.currentFeeInfo);
			}
			this.startFeePolling();
			this.checkPaymentStatus();
		},
		// 生成付款二维码
		generateFeeQrcode(blogInfo) {
			const qrEl = this.$refs.feeQrCodeUrl || document.getElementById('feeQrCodeUrl');
			if (qrEl) {
				qrEl.innerHTML = "";
			}
			const feeStatus = this.normalizeFeeStatus(blogInfo.feeStatus);
			const qrData = {
				business: "pay",
				subtype: this.getFeeSubtype(blogInfo, this.feeScene),
				feeStatus: feeStatus,
				annualFeePrice: blogInfo.annualFeePrice || 0,
			};
			if (feeStatus === 2) {
				qrData.remainingDays = blogInfo.remainingDays;
				qrData.feeExpireTime = blogInfo.feeExpireTime;
			}
			console.log('生成付款二维码:', JSON.stringify(qrData), '身份:', this.getFeeDialogTitle(blogInfo, this.feeScene));
			if (!qrEl) return;
			this.feeQrcode = new QRCode(qrEl, {
				text: JSON.stringify(qrData),
				width: 200,
				height: 200,
				colorDark: "#000000",
				colorLight: "#ffffff",
				correctLevel: QRCode.CorrectLevel.H,
			});
			this.$nextTick(() => {
				this.removeQrcodeTitle();
			});
		},
		// 移除二维码元素的 title 属性，防止鼠标悬停泄露内容
		removeQrcodeTitle() {
			const container = document.getElementById('feeQrCodeUrl');
			if (!container) return;
			container.removeAttribute('title');
			const children = container.querySelectorAll('*');
			children.forEach(el => el.removeAttribute('title'));
		},
		// 开始轮询付款状态（每3秒检查一次，最多轮询100次=5分钟）
		startFeePolling() {
			this.stopFeePolling();
			this.feePollingTimer = setInterval(() => {
				this.feePollingCount++;
				if (this.feePollingCount > 100) {
					console.log('付款轮询超时，停止轮询');
					this.stopFeePolling();
					return;
				}
				this.checkPaymentStatus();
			}, 3000);
		},
		// 停止轮询
		stopFeePolling() {
			if (this.feePollingTimer) {
				clearInterval(this.feePollingTimer);
				this.feePollingTimer = null;
			}
		},
		// 检查付款状态
		async checkPaymentStatus() {
			try {
				const spaceInfo = await this.fetchFeeSpaceInfo(this.feeScene || 'zhike');
				if (!spaceInfo) return;

				const feeStatus = this.normalizeFeeStatus(spaceInfo.feeStatus);
				console.log(`付款轮询 #${this.feePollingCount}: scene=${this.feeScene} feeStatus=${feeStatus}`, spaceInfo);

				if (this.isFeePaidStatus(feeStatus, spaceInfo, true)) {
					this.stopFeePolling();
					this.onPaymentSuccess(feeStatus);
				}
			} catch (err) {
				console.error('付款状态检查失败:', err);
			}
		},
		onPaymentSuccess(feeStatus) {
			if (this.feeSuccessHandled) return;
			this.feeSuccessHandled = true;
			this.stopFeePolling();
			this.paymentSuccess = true;
			const qrEl = this.$refs.feeQrCodeUrl || document.getElementById('feeQrCodeUrl');
			if (qrEl) {
				qrEl.innerHTML = "";
			}
			this.feeQrcode = null;
			this.$message.success('支付成功');

			setTimeout(() => {
				this.feeDialogVisible = false;
				setTimeout(() => {
					if (this.pendingNavigatePath) {
						const path = this.pendingNavigatePath;
						this.pendingNavigatePath = '';
						const navIndex = this.navSrc.findIndex(item => item.path === path);
						if (navIndex !== -1) {
							window.localStorage.setItem("index", navIndex);
							this.current = navIndex;
						}
						this.$router.push({ path });
					}
				}, 500);
			}, 1500);
		},
		// 手动确认已支付
		confirmPaymentManually() {
			this.checkPaymentStatus();
		},
		// 弹窗关闭后清除
		handleFeeDialogClosed() {
			this.stopFeePolling();
			if (this.$refs.feeQrCodeUrl) {
				this.$refs.feeQrCodeUrl.innerHTML = "";
			}
			this.feeQrcode = null;
			this.feePollingCount = 0;
			this.paymentSuccess = false;
			this.currentFeeInfo = null;
			this.feeSuccessHandled = false;
		},
		// 重新计算秘书台未读数
		// 修改 slider-bar.vue 中的 recalculateSecretaryUnread 方法
		async recalculateSecretaryUnread() {
			const timestamp = new Date().toLocaleTimeString();
			console.log(`[${timestamp}] === slider-bar: 开始重新计算秘书台未读数 ===`);
			return new Promise(async (resolve, reject) => {
				try {
				// 类型 0默认群聊 1会议 2活动 3婚礼 4宴席 5殡礼 6庆典 7生日会
				let arr = [0, 1, 2, 3, 4, 5, 6, 7];
				let countAll = 0;
				let processedGroups = 0;
				let unreadGroups = 0;
				
				// 获取当前正在聊天的目标ID
				const currentTargetId = this.$store.state.rongyun.targetId;
				console.log(`[${timestamp}] === slider-bar: 当前正在聊天的目标ID: ${currentTargetId} ===`);
				
				// 顺序执行，确保countAll正确累加
				for (let i = 0; i < arr.length; i++) {
					const groupType = arr[i];
					console.log(`[${timestamp}] === slider-bar: 处理群组类型 ${groupType} ===`);
					try {
					const res = await this.$api.group.groupGroupInfoList(groupType);
					const groupList = res.result || [];
					console.log(`[${timestamp}] === slider-bar: 群组类型 ${groupType} 共有 ${groupList.length} 个群组 ===`);
					for (let j = 0; j < groupList.length; j++) {
							const p = groupList[j];
								processedGroups++;
								
								// 检查群组是否已被移出
								const kickedGroups = JSON.parse(localStorage.getItem('kickedGroups') || '[]');
								if (kickedGroups.includes(p.id)) {
									console.log(`[${timestamp}] === slider-bar: 群组 ${p.id} 已被移出，跳过未读数计算 ===`);
									continue;
								}
								
								// 如果当前正在该群聊天，跳过未读数计算（不显示红点）
								if (currentTargetId && currentTargetId.toString() === p.id.toString()) {
									console.log(`[${timestamp}] === slider-bar: 群组 ${p.id} 正在聊天中，跳过未读数计算 ===`);
									continue;
								}
								
								try {
									const conversation = this.RongIMClient.Conversation.get({
										targetId: p.id,
										type: window.RongIMLib.CONVERSATION_TYPE.GROUP,
										});
									
									if (!conversation || typeof conversation.getUnreadCount !== 'function') {
										console.error(`[${timestamp}] === slider-bar: 群组 ${p.id} 会话对象无效或缺少 getUnreadCount 方法 ===`);
										continue;
									}
									
									try {
										const count = await conversation.getUnreadCount();
										console.log(`[${timestamp}] === slider-bar: 群组 ${p.id} (${p.name}) 未读消息数: ${count} ===`);
										if (count > 0) {
											countAll += 1;
											unreadGroups++;
											console.log(`[${timestamp}] === slider-bar: 群组 ${p.id} 计入未读数，当前累计: ${countAll} ===`);
										}
									} catch (error) {
										console.error(`[${timestamp}] === slider-bar: 调用 getUnreadCount 失败:`, error);
										continue;
									}
								} catch (error) {
									console.error(`[${timestamp}] === slider-bar: 获取群组 ${p.id} 未读数失败:`, error);
								}
					}
					} catch (error) {
					console.error(`[${timestamp}] === slider-bar: 获取群组类型 ${groupType} 的列表失败:`, error);
					}
				}
				
				console.log(`[${timestamp}] === slider-bar: 未读消息数计算完成 ===`);
				console.log(`[${timestamp}] === slider-bar: 处理群组总数: ${processedGroups} ===`);
				console.log(`[${timestamp}] === slider-bar: 未读群组数量: ${unreadGroups} ===`);
				console.log(`[${timestamp}] === slider-bar: 通过手动遍历计算的秘书台未读消息数: ${countAll} ===`);
				
				// 更新Vuex状态
				console.log(`[${timestamp}] === slider-bar: 更新Vuex中的秘书台未读数为 ${countAll} ===`);
				this.$store.commit('updateGroumNum', countAll);
				
				// 添加强制组件更新
				this.$forceUpdate();
				
				// 直接操作DOM更新秘书台未读数量，确保实时显示
				this.updateSecretaryBadgeDirectly();
				
				resolve(countAll);
				} catch (error) {
				console.error(`[${timestamp}] === slider-bar: 计算秘书台未读数失败:`, error);
				console.log(`[${timestamp}] === slider-bar: 计算失败，设置秘书台未读数为 0 ===`);
				this.$store.commit('updateGroumNum', 0);
				this.$store.commit('changeGroupList');
				this.updateSecretaryBadgeDirectly();
				resolve(0);
				}
			});
		},

		// 强制刷新指定群组的未读数 - 解决重复消息不更新问题
		async forceUpdateGroupUnread(groupId) {
			try {
				console.log(`强制刷新群组 ${groupId} 的未读状态`);
				
				// 直接重新计算所有秘书台未读数，确保逻辑一致
				await this.recalculateSecretaryUnread();
				
				// 额外：通知所有组件状态已更新
				this.$root.$emit('secretary-unread-updated', {
					groupId: groupId,
					timestamp: Date.now()
				});
				
			} catch (error) {
				console.error('强制刷新群组未读数失败:', error);
				// 失败时回退到重新计算
				this.recalculateSecretaryUnread();
			}
		},
		// 实时更新秘书台未读数 - 更轻量级的实现
		async updateSecretaryUnreadRealtime() {
			try {
				// 直接重新计算所有秘书台未读数，确保逻辑一致
				await this.recalculateSecretaryUnread();
				
				// 广播更新事件
				this.$root.$emit('secretary-unread-updated', {
					timestamp: Date.now()
				});
				
			} catch (error) {
				console.error('更新秘书台未读数失败:', error);
				// 失败时回退到重新计算
				this.recalculateSecretaryUnread();
			}
		},
		//获取艺术家状态  0未开通 1 开通
		getArtistStatus() {
			return new Promise((resolve, reject) => {
				api.userMsg.memberArtistStatus().then((res) => {
					this.artistStatus = res.result.isApply;
					this.avatar = res.result.avatar;
					this.lastKnownArtistStatus = res.result.isApply;
					resolve(res.result); // 成功时解析
				});
				//获取音乐家状态 审核状态 0待审核 1审核成功 2审核失败
				api.userMsg.memberMusicStatus().then(res => {
					if (res.result) {
						this.musicStatus = res.result.auditStatus || 0
					} else {
						this.musicStatus = 0
					}
					this.lastKnownMusicStatus = this.musicStatus;
				});
			}).catch(err => {
				reject(err); // 失败时拒绝
			});		
			
		},
		// 退出登录
		logout() {
			api.index.logout({ uuid: localStorage.getItem('uuid') }).then((res) => {
				if (res.code == "200") {
					// 删除本地存储的token
					localStorage.removeItem("token");
					localStorage.removeItem("uuid");
					localStorage.clear()
					this.RongIMClient.disconnect().then(() => console.log('断开链接成功'));
					this.$router.push("/login");
				}
			});
		},
		deleteFriend(targetId) {
			// conversation 会话实例
			const conversation = this.RongIMClient.Conversation.get({
				targetId: targetId,
				type: window.RongIMLib.CONVERSATION_TYPE.PRIVATE
			});
			conversation.destory().then(() => {
				console.log('删除会话成功')
			});
		},
		handleFriendTag(targetId) {
			const type = window.RongIMLib.CONVERSATION_TYPE.PRIVATE
			// 会话数组
			const conversations = [{
				type,
				targetId: targetId
			}]
			this.RongIMClient.Tag.get('0').then(tag => {
				tag.addConversations(conversations).then(code => {
					// 添加成功
					if (code === 0) {
						this.$store.dispatch("updateList", this);
					}
				})
			})
		},
		// 立即更新秘书台未读数量 - 高效实时更新方法
		immediateUpdateSecretaryUnread() {
			try {
				console.log('立即更新秘书台未读数量');
				
				// 获取秘书台未读数量
				const unreadCount = this.$store.state.updateNum.upDateGroupNum;
				console.log('秘书台未读数量:', unreadCount);
				
				// 直接操作DOM更新秘书台的未读数量
				const sliderNav = document.querySelector('.slider-nav');
				if (sliderNav) {
					const navItems = sliderNav.querySelectorAll('li');
					navItems.forEach((item, index) => {
						const spanElements = item.querySelectorAll('span');
						spanElements.forEach(span => {
							if (span.textContent === '秘书台') {
								// 检查是否已有未读数量标签
								// let badgeElement = item.querySelector('.badge, .badge2');
								// if (unreadCount > 0) {
								// 	if (badgeElement) {
								// 		// 更新现有标签
								// 		badgeElement.textContent = unreadCount;
								// 		badgeElement.className = unreadCount < 10 ? 'badge' : 'badge2';
								// 	} else {
								// 		// 创建新标签
								// 		badgeElement = document.createElement('span');
								// 		badgeElement.className = unreadCount < 10 ? 'badge' : 'badge2';
								// 		badgeElement.textContent = unreadCount;
								// 		item.appendChild(badgeElement);
								// 	}
								// } else {
								// 	// 移除未读数量标签
								// 	if (badgeElement) {
								// 		badgeElement.remove();
								// 	}
								// }
							}
						});
					});
				}
				console.log('立即更新秘书台未读数量完成');
			} catch (error) {
				console.error('立即更新秘书台未读数量失败:', error);
			}
		},
		// 启动状态轮询
		startStatusPolling() {
			// 每5分钟检查一次状态（不会频繁打扰用户）
			this.statusCheckTimer = setInterval(() => {
				this.checkStatusChange();
			}, 5 * 60 * 1000); // 5分钟
			
			// 立即检查一次
			this.checkStatusChange();
			
			// 启动融云连接状态轮询
			this.startRongyunStatusPolling();
		},
		
		// 启动融云连接状态轮询
		startRongyunStatusPolling() {
			// 每30秒检查一次融云连接状态
			this.rongyunStatusTimer = setInterval(() => {
				this.checkRongyunStatus();
			}, 30 * 1000); // 30秒
			
			// 立即检查一次
			this.checkRongyunStatus();
		},
		
		// 停止轮询
		stopStatusPolling() {
			if (this.statusCheckTimer) {
				clearInterval(this.statusCheckTimer);
				this.statusCheckTimer = null;
			}
			
			if (this.rongyunStatusTimer) {
				clearInterval(this.rongyunStatusTimer);
				this.rongyunStatusTimer = null;
			}
		},
		
		// 检查融云连接状态
		checkRongyunStatus() {
			if (this.RongIMClient) {
				// 检查连接状态
				const connectionStatus = this.RongIMClient.getConnectionStatus();
				console.log('融云连接状态检查:', connectionStatus);
				
				// 如果连接状态不是已连接(0)，尝试重连
				if (connectionStatus !== 0) {
					console.log('融云连接状态异常，尝试重连...');
					try {
						this.RongIMClient.reconnect();
					} catch (error) {
						console.error('融云重连失败:', error);
					}
				}
			}
		},
		
		// 检查状态变化
		async checkStatusChange() {
			try {
				const [artistRes, musicRes] = await Promise.all([
					api.userMsg.memberArtistStatus(),
					api.userMsg.memberMusicStatus()
				]);
				
				const newArtistStatus = artistRes.result.isApply;
				const newMusicStatus = musicRes.result.auditStatus || 0;
				
				// 检测状态变化
				if (newArtistStatus !== this.lastKnownArtistStatus || 
					newMusicStatus !== this.lastKnownMusicStatus) {
					
					console.log('检测到状态变化，更新侧边栏');
					this.artistStatus = newArtistStatus;
					this.musicStatus = newMusicStatus;
					this.avatar = artistRes.result.avatar;
					
					// 更新缓存值
					this.lastKnownArtistStatus = newArtistStatus;
					this.lastKnownMusicStatus = newMusicStatus;
					
					// 可选：状态变化时给用户提示
					this.$message.success('您的申请状态已更新');
				}
			} catch (error) {
				console.error('状态检查失败:', error);
			}
		},
		
		// 直接操作DOM更新秘书台未读数量，确保实时显示
		updateSecretaryBadgeDirectly() {
			try {
				// console.log('直接操作DOM更新秘书台未读数量');
				
				// 获取秘书台未读数量
				const unreadCount = this.$store.state.updateNum.upDateGroupNum;
				console.log('秘书台未读数量:', unreadCount);
				
				// 直接操作DOM更新秘书台的未读数量
				const sliderNav = document.querySelector('.slider-nav');
				if (sliderNav) {
					const navItems = sliderNav.querySelectorAll('li');
					// 遍历所有菜单项，通过文本内容找到秘书台
					navItems.forEach((item) => {
						const spanElements = item.querySelectorAll('span');
						let isSecretaryItem = false;
						
						// 检查是否是秘书台菜单项
						spanElements.forEach(span => {
							if (span.textContent === '秘书台') {
								isSecretaryItem = true;
							}
						});
						
						// if (isSecretaryItem) {
						// 	// 检查是否已有未读数量标签
						// 	let badgeElement = item.querySelector('.badge, .badge2');
						// 	if (unreadCount > 0) {
						// 		if (badgeElement) {
						// 			// 显示数字
						// 			badgeElement.textContent = unreadCount;
						// 			badgeElement.className = unreadCount < 10 ? 'badge' : 'badge2';
						// 		} else {
						// 			// 创建新标签，显示数字
						// 			badgeElement = document.createElement('span');
						// 			badgeElement.className = unreadCount < 10 ? 'badge' : 'badge2';
						// 			badgeElement.textContent = unreadCount;
						// 			item.appendChild(badgeElement);
						// 		}
						// 	} else {
						// 		// 移除未读数量标签
						// 		if (badgeElement) {
						// 			badgeElement.remove();
						// 		}
						// 	}
						// }
					});
				}
				// console.log('直接操作DOM更新秘书台未读数量完成');
			} catch (error) {
				// console.error('直接操作DOM更新秘书台未读数量失败:', error);
			}
		},
		// 处理秘书台未读更新事件
		handleSecretaryUnreadUpdated(event) {
			const timestamp = new Date().toLocaleTimeString();
			console.log(`[${timestamp}] === slider-bar: 收到秘书台未读更新事件 ===`);
			console.log(`[${timestamp}] === slider-bar: 事件数据:`, event);
			
			// 立即重新计算秘书台未读数
			this.recalculateSecretaryUnread().then(count => {
				console.log(`[${timestamp}] === slider-bar: 秘书台未读数计算结果: ${count} ===`);
				// 强制更新DOM，确保即使在私信视图也能看到未读数量更新
				this.updateSecretaryBadgeDirectly();
				// 强制组件更新，确保界面能实时显示最新的未读数量
				this.$forceUpdate();
				
				// 再次更新DOM，确保更新生效
				setTimeout(() => {
					this.updateSecretaryBadgeDirectly();
					this.$forceUpdate();
					console.log(`[${timestamp}] === slider-bar: 再次更新秘书台未读数量 ===`);
				}, 100);
			});
		},
	},
};
</script>

<style scoped>
.slider {
	flex-shrink: 0;
	width: 70px;
	height: 100%;
	background: #28a8cf;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 42px 0 0;
	box-sizing: border-box;
	user-select: none;
}

.header {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.avatar {
	width: 40px;
	height: 40px;
	opacity: 1;
	border: 1px solid #ffffff;
	border-radius: 50%;
	overflow: hidden;
	object-fit: none;
	margin-bottom: 20px;
	cursor: pointer;
	background: #fff;
}

.avatar img {
	height: 100%;
	width: 100%;
	/* object-fit: contain; */
}

.slider-nav {
	flex: 1;
	width: 100%;
	display: flex;
	flex-direction: column;
	overflow-y: auto;
}

.slider-nav li {
	/* width: 20px; */
	flex-direction: column;
	align-items: center;
	display: flex;
	padding: 0 5px;
	margin: 10px 0;
	position: relative;
	cursor: pointer;
}

.slider-nav li img {
	width: 24px;
	height: 24px;
	margin-bottom: 4px;
}

.slider-nav li span {
	color: #ffffff;
	font-size: 12px;
}

.slider-nav .badge {
	position: absolute;
	width: 16px;
	height: 16px;
	line-height: 16px;
	font-size: 12px;
	text-align: center;
	background: #ff6632;
	border-radius: 50%;
	top: -8px;
	right: 13px;
}

.slider-nav .badge2 {
	position: absolute;
	width: 21px;
	height: 16px;
	line-height: 16px;
	font-size: 12px;
	text-align: center;
	background: #ff6632;
	border-radius: 8px;
	top: -8px;
	right: 13px;
}

.nickName-box {
	font-size: 14px;
	color: #fff;
	margin-bottom: 10px;
}
</style>

<style>
.fee-dialog .el-dialog__header {
	padding: 20px 20px 10px;
}
.fee-dialog .el-dialog__title {
	font-size: 15px;
	color: #333;
	line-height: 1.5;
}
.fee-dialog .el-dialog__body {
	padding: 20px;
}
.fee-dialog-body {
	text-align: center;
}
.fee-dialog-body .fee-status-text {
	font-size: 14px;
	color: #606266;
	line-height: 1.6;
	margin-bottom: 15px;
}
.fee-dialog-body .fee-price {
	font-size: 18px;
	color: #ff6632;
	margin-bottom: 20px;
}
.fee-dialog-body .payment-success-area {
	padding: 30px 0;
}
.fee-dialog-body .payment-success-area .success-icon {
	width: 56px;
	height: 56px;
	line-height: 56px;
	border-radius: 50%;
	background: #67c23a;
	color: #fff;
	font-size: 32px;
	margin: 0 auto 15px;
}
.fee-dialog-body .payment-success-area .success-text {
	font-size: 20px;
	color: #67c23a;
	font-weight: bold;
}
.fee-dialog-body .fee-qrcode-area {
	display: flex;
	justify-content: center;
	margin-bottom: 15px;
}
.fee-dialog-body .fee-qrcode-area > div {
	width: 200px;
	height: 200px;
}
.fee-dialog-body .fee-tip {
	font-size: 13px;
	color: #909399;
}
</style>